

import { IconCircleFilled } from '@tabler/icons-react'

const OwnerCircle = () => {
  return (
    <div
      style={{
        display: 'flex',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: '#ffa500',
        borderRadius: '50%',
        marginRight: '0.5rem',
      }}
    >
      <IconCircleFilled
        style={{
          borderWidth: '2px',
          borderStyle: 'solid',
          borderColor: '#fff',
          borderRadius: '100%',
        }}
        color='#ffa500'
        size={20}
      />
    </div>
  )
}

export default OwnerCircle
